// import React, { useState } from "react";
// import { FaCopy, FaCheck, FaChevronDown } from "react-icons/fa6";
// import { useStateContext } from "../contexts/ContextProvider";

// const SharedLinks = ({ sharedLink, keys }) => {
//   const [isCopied, setIsCopied] = useState(false);
//   const [isPasswordCopied, setIsPasswordCopied] = useState(false);
//   const [copiedIndexes, setCopiedIndexes] = useState({});
//   const [passwordCopiedIndexes, setPasswordCopiedIndexes] = useState({});
//   const [showAll, setShowAll] = useState(false);
//   const { currentColor, currentMode } = useStateContext();

//   const tableStyle = {
//     width: "100%",
//     margin: "auto",
//     borderCollapse: "collapse",
//     textAlign: "left",
//   };

//   const thTdStyle = {
//     padding: "8px",
//     borderBottom: "1px solid #ddd",
//     color: "#4b5563",
//     fontWeight: 500,
//   };

//   const formatDate = (dateString) => {
//     return dateString.split("T")[0];
//   };

//   const handleCopy = (text, type, index) => {
//     copyToClipboard(text);
//     if (type === "url") {
//       setCopiedIndexes((prev) => ({ ...prev, [index]: true }));
//       setTimeout(() => {
//         setCopiedIndexes((prev) => ({ ...prev, [index]: false }));
//       }, 2000);
//     } else if (type === "password") {
//       setPasswordCopiedIndexes((prev) => ({ ...prev, [index]: true }));
//       setTimeout(() => {
//         setPasswordCopiedIndexes((prev) => ({ ...prev, [index]: false }));
//       }, 2000);
//     }
//   };

//   const copyToClipboard = (text) => {
//     if (navigator.clipboard && window.isSecureContext) {
//       navigator.clipboard.writeText(text);
//     } else {
//       const textArea = document.createElement("textarea");
//       textArea.value = text;
//       textArea.style.position = "absolute";
//       textArea.style.left = "-999999px";
//       document.body.prepend(textArea);
//       textArea.select();
//       try {
//         document.execCommand("copy");
//       } catch (error) {
//         console.error(error);
//       } finally {
//         textArea.remove();
//       }
//     }
//   };

//   const styles = {
//     container: {
//       position: "relative",
//     },
//     header: {
//       borderBottom: "1px solid #ddd",
//       paddingBottom: "15px",
//       paddingTop: "10px",
//       marginBottom: "10px",
//       textAlign: "left",
//       fontSize: "1.3rem",
//       color: "#4b5563",
//     },
//     tableContainer: {
//       maxHeight: "300px", // Adjust height as needed
//       overflowY: "auto",
//       border: "1px solid #ddd",
//       borderRadius: "4px",
//     },
//     tableRow: {
//       borderBottom: "1px solid #ddd",
//     },
//     tableCell: {
//       padding: "10px",
//       verticalAlign: "top",
//     },
//     copyButton: {
//       cursor: "pointer",
//       background: "transparent",
//       padding: "5px",
//       marginLeft: "10px",
//       color: currentColor,
//     },
//     scrollButton: {
//       position: "absolute",
//       bottom: "10px",
//       right: "10px",
//       background: "#ddd",
//       borderRadius: "50%",
//       border: "none",
//       padding: "10px",
//       cursor: "pointer",
//       boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
//       transition: "box-shadow 0.3s ease",
//     },
//     scrollButtonHover: {
//       boxShadow: "0 6px 12px rgba(0,0,0,0.3)",
//     },
//     noLinks: {
//       textAlign: "center",
//       padding: "20px",
//       fontSize: "18px",
//       color: "#888",
//       animation: "fadeIn 1s ease-in-out",
//     },
//   };

//   return (
//     <div style={styles.container}>
//       {sharedLink && sharedLink.length > 0 ? (
//         <>
//           <h3 style={styles.header}>Shared Links</h3>
//           <div style={styles.tableContainer}>
//             <table style={tableStyle}>
//               <thead>
//                 <tr>
//                   <th style={thTdStyle}>Link</th>
//                   <th style={thTdStyle}>Password</th>
//                   <th style={thTdStyle}>Expiry Date</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {sharedLink
//                   .slice(0, showAll ? sharedLink.length : 2)
//                   .map((link, index) => (
//                     <tr key={index} style={styles.tableRow}>
//                       <td style={styles.tableCell}>
//                         {`${window.location.origin}/${keys}/${link.token.key}`}
//                         <button
//                           style={styles.copyButton}
//                           onClick={() =>
//                             handleCopy(
//                               `${window.location.origin}/${keys}/${link.token.key}`,
//                               "url",
//                               index
//                             )
//                           }
//                         >
//                           {copiedIndexes[index] ? <FaCheck /> : <FaCopy />}
//                         </button>
//                       </td>
//                       <td style={styles.tableCell}>
//                         {link.password}
//                         <button
//                           style={styles.copyButton}
//                           onClick={() =>
//                             handleCopy(link.password, "password", index)
//                           }
//                         >
//                           {passwordCopiedIndexes[index] ? (
//                             <FaCheck />
//                           ) : (
//                             <FaCopy />
//                           )}
//                         </button>
//                       </td>
//                       <td style={styles.tableCell}>
//                         {formatDate(link.passwordExpiry)}
//                       </td>
//                     </tr>
//                   ))}
//               </tbody>
//             </table>
//           </div>
//           {!showAll && sharedLink.length > 2 && (
//             <button
//               style={styles.scrollButton}
//               onClick={() => setShowAll(true)}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.boxShadow =
//                   styles.scrollButtonHover.boxShadow)
//               }
//               onMouseOut={(e) =>
//                 (e.currentTarget.style.boxShadow =
//                   styles.scrollButton.boxShadow)
//               }
//             >
//               <FaChevronDown />
//             </button>
//           )}
//         </>
//       ) : (
//         <div style={styles.noLinks}>
//           <p>No Shared Links Available</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SharedLinks;
import React, { useState } from "react";
import { FaCopy, FaCheck, FaChevronDown } from "react-icons/fa6";
import { useStateContext } from "../contexts/ContextProvider";

const SharedLinks = ({ sharedLink, keys }) => {
  const [copiedIndexes, setCopiedIndexes] = useState({});
  const [passwordCopiedIndexes, setPasswordCopiedIndexes] = useState({});
  const [showAll, setShowAll] = useState(false);
  const { currentColor } = useStateContext();

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    textAlign: "left",
  };

  const thTdStyle = {
    padding: "8px",
    borderBottom: "1px solid #ddd",
    color: "#4b5563",
    fontWeight: 500,
  };

  const formatDate = (dateString) => {
    return dateString.split("T")[0];
  };

  const handleCopy = (text, type, index) => {
    copyToClipboard(text);
    if (type === "url") {
      setCopiedIndexes((prev) => ({ ...prev, [index]: true }));
      setTimeout(() => {
        setCopiedIndexes((prev) => ({ ...prev, [index]: false }));
      }, 2000);
    } else if (type === "password") {
      setPasswordCopiedIndexes((prev) => ({ ...prev, [index]: true }));
      setTimeout(() => {
        setPasswordCopiedIndexes((prev) => ({ ...prev, [index]: false }));
      }, 2000);
    }
  };

  const copyToClipboard = (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text);
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "absolute";
      textArea.style.left = "-999999px";
      document.body.prepend(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
      } catch (error) {
        console.error(error);
      } finally {
        textArea.remove();
      }
    }
  };

  const styles = {
    container: {
      position: "relative",
    },
    header: {
      borderBottom: "1px solid #ddd",
      paddingBottom: "15px",
      paddingTop: "10px",
      marginBottom: "10px",
      textAlign: "left",
      fontSize: "1.3rem",
      color: "#4b5563",
    },
    tableContainer: {
      maxHeight: "300px", // Adjust height as needed
      overflowY: "auto", // Add overflow-y for vertical scrolling
    },
    tableRow: {
      borderBottom: "1px solid #ddd",
    },
    tableCell: {
      padding: "10px",
      verticalAlign: "top",
    },
    copyButton: {
      cursor: "pointer",
      background: "transparent",
      padding: "5px",
      marginLeft: "10px",
      color: currentColor,
    },
    scrollButton: {
      position: "absolute",
      bottom: "10px",
      right: "10px",
      background: "#ddd",
      // background:currentColor,
      // color:"white",
      borderRadius: "50%",
      border: "none",
      padding: "10px",
      cursor: "pointer",
      boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
      transition: "box-shadow 0.3s ease",
    },
    scrollButtonHover: {
      boxShadow: "0 6px 12px rgba(0,0,0,0.3)",
    },
    noLinks: {
      textAlign: "center",
      padding: "20px",
      fontSize: "18px",
      color: "#888",
      animation: "fadeIn 1s ease-in-out",
    },
  };

  return (
    <div style={styles.container}>
      {sharedLink && sharedLink.length > 0 ? (
        <>
          <h3 style={styles.header}>Shared Links</h3>
          <div style={styles.tableContainer}>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thTdStyle}>Link</th>
                  <th style={thTdStyle}>Password</th>
                  <th style={thTdStyle}>Expiry Date</th>
                </tr>
              </thead>
              <tbody>
                {sharedLink
                  .slice(0, showAll ? sharedLink.length : 2)
                  .map((link, index) => (
                    <tr key={index} style={styles.tableRow}>
                      <td style={styles.tableCell}>
                        {`${window.location.origin}/${keys}/${link.token.key}`}
                        <button
                          style={styles.copyButton}
                          onClick={() =>
                            handleCopy(
                              `${window.location.origin}/${keys}/${link.token.key}`,
                              "url",
                              index
                            )
                          }
                        >
                          {copiedIndexes[index] ? <FaCheck /> : <FaCopy />}
                        </button>
                      </td>
                      <td style={styles.tableCell}>
                        {link.password}
                        {link.password && (
                          <button
                            style={styles.copyButton}
                            onClick={() =>
                              handleCopy(link.password, "password", index)
                            }
                          >
                            {passwordCopiedIndexes[index] ? (
                              <FaCheck />
                            ) : (
                              <FaCopy />
                            )}
                          </button>
                        )}
                      </td>
                      <td style={styles.tableCell}>
                        {formatDate(link.passwordExpiry)}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          {!showAll && sharedLink.length > 2 && (
            <button
              style={styles.scrollButton}
              onClick={() => setShowAll(true)}
              onMouseOver={(e) =>
                (e.currentTarget.style.boxShadow =
                  styles.scrollButtonHover.boxShadow)
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.boxShadow =
                  styles.scrollButton.boxShadow)
              }
            >
              <FaChevronDown />
            </button>
          )}
        </>
      ) : (
        <div style={styles.noLinks}>
          <p>No Shared Links Available</p>
        </div>
      )}
    </div>
  );
};

export default SharedLinks;
